<!--单选框组件 by linsc 
1.使用方法，字段的FIELD_TYPE设置为radio
2.给字段的FIELD_DICT_NEMA字典赋值即可
-->
<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <el-radio-group v-model="field.DEFAULT_VALUE" :disabled="isDisabled">
      <el-radio v-for="(item, index) in options" :class="['background-' + item.value,	    
      { 'custom-checkBox': item.custom == '1' }]" :key="index" :label="item.value"
        :disabled="item.isDisable" @click.native.prevent="clickitem(item)">{{ item.label }}</el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { isString } from "util";

export default {
  data () {
    return {
      itemClass: "self-radio",
      isDisabled: false,
      isMuti: false,  //是否是多选
      optionsAll: "",
      options: "",
      chooseAll: false,
      triggerType: "custom",//校验类型 custom是自定义的
      rules: [],
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
    if (this.isRequired)
      this.itemClass += " self-radio-required";

    // this.initData();
    this.initDict();
  },
  computed: {
    title: function () {
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    messageChange: function () {
      return this.field.message;
    },
    dictChange: function () {
      return this.field.FIELD_DICT_FILTER || this.field.FIELD_DICT_NAME;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
  },
  methods: {
    initDict () {
      if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.optionsAll = [];
        this.options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        //展示但是不可编辑
        let disableArr = [];
        if (this.field.FIELD_DICT_DISABLE) {
          try {
            let disable = this.field.FIELD_DICT_DISABLE;
            disableArr = Array.isArray(disable) ? disable : isString(disable) ? disable.split(",") : [];
          } catch (exception) {
            disableArr = [];
          }
        }

        _.filter(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO 不可编辑的要disable
          if (disableArr) {
            disableArr.map(i => {
              if (item.DICT_ITEM == i) {
                item.IS_DISABLE = true;
              }
            });
          }
          this.optionsAll.push(this.getOptionItem(item));;
        });

        if (showArr.length == 0 || showArr.length == this.field.FIELD_DICT_NAME.length) {
          this.options = this.optionsAll;
        } else {
          // 如果当前值不在过滤后的字典内，将当前值清掉
          if (_.indexOf(showArr, this.field.DEFAULT_VALUE) == -1) {
            this.field.DEFAULT_VALUE = "";
          }

          _.filter(this.field.FIELD_DICT_NAME, (item) => {
            // 判断机构ORG_CODE TODO 
            for (let j = 0; j < showArr.length; j++) {
              if (item.DICT_ITEM == showArr[j]) {
                this.options.push(this.getOptionItem(item));
              }
            }
            this.optionsAll.push(this.getOptionItem(item));;
          });
        }
      }
      // consoleLog("单选：" + this.field.FIELD_ID + "字典==" + this.field.FIELD_DICT_NAME);
    },
    getOptionItem (item){
      return {
        "value": item.DICT_ITEM, 
        "label": item.DICT_ITEM_NAME, 
        "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false, 
        "custom": item.custom ? item.custom : false 
      };
    },
    validatorField: function (rule, value, callback) {
      value = this.field.DEFAULT_VALUE;
      if (this.isBaseUI) { // 多选框选中和都不选中都广播值变更事件
        this.$emit("field-change", this.field);
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
      }

      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        return callback();
      }
    },
    clickitem (e) {
      //单选组件 默认必须选一个，重复点击无效
      //但是允许特殊情况，设置了允许取消且非禁止编辑状态可以取消勾选
      if (!e.isDisable && this.field.allowCancel && this.field.DEFAULT_VALUE) {
        this.field.DEFAULT_VALUE =  "";
        consoleLog(this.field.FIELD_TITLE+"单选框取消勾选");
      }else{
        this.field.DEFAULT_VALUE = e.value;
      }
    }
    // initData () {
    //   if(this.field.DEFAULT_VALUE === "false" || this.field.DEFAULT_VALUE == 0 || !this.field.DEFAULT_VALUE){
    //     this.checked = field;
    //   } else {
    //     this.checked = true;
    //   }
    // },
    // handleChecked (value) {
    //   this.field.DEFAULT_VALUE = "" + value;
    // },
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-radio-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-radio-required/g, "");
      }
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dictChange: function (val) {
      this.initDict();
    },
    dataChange: function (val) {
      consoleLog("单选框radio，dataChange值变化", val);
      this.field.message = "";
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // this.initData();
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.itemClass = this.itemClass.replace("ocrIcon","");
        this.itemClass = this.itemClass.replace("zzIcon","");
        this.itemClass = this.itemClass.replace("zdIcon","");
        if (val == "1") {
          this.itemClass += " ocrIcon";
        } else if (val == "2") {
          this.itemClass += " zzIcon";
        } else if (val == "3") {
          this.itemClass += " zdIcon";
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less">
.self-radio {
  width: 100%;
  display: flex;
  min-height: 40px;
  height: auto !important;
  .el-form-item__label {
    // font-size: 20px;原始vtm
    font-size: 14px;    
    min-width: 170px;
    text-align: right;
    width: 205px;
  }
  .el-form-item__content {
    // font-size: 20px;原始vtm
    font-size: 14px;
    color: #000;
    flex: 1;
    .el-radio-group {
    
      .el-radio {
        display: inline-flex;
        align-items: center;
        // margin-left: 20px;
        margin: 5px;
        text-align: center;
        // width: 285px;
        min-width: 180px;
        height: 40px;
        background: #fff;
        // border: 2px solid #a5a9b3;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 0 24px 0 24px;
        &.is-checked {
          border-color: #e5c48a;
          .el-radio__label {        
            color: #e5c48a;            
          }
          // &.is-disabled {
          //   border-color: rgba(70, 102, 234, 1);//原始  
          // }
        }
        // &.is-disabled {
        //   color: #b6bcc5;
        //   background-color: #ebecf2;
        //   border-color: #9fa2ae;
        //   .el-radio__label {
        //     color: inherit;
        //   }
        // }
        // &:first-child {
        //   margin-left: 0;
        // }
        .el-radio__input {
          display: none;
        }
        .el-radio__label {
          // font-size: 20px;原始vtm
          font-size: 14px;
          display: block;
          margin: 0 auto;
          padding-left: 0;
        }
      }
      .el-radio {
        // width: 190px;
        // box-sizing: border-box;
      }
    }
  }
}
.self-radio-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/radioItem.vue